(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    /* sharp photo fades in over its blurred placeholder */
    function shown(img) { img.classList.add('is-in'); setTimeout(function () { if (img.parentNode) img.parentNode.classList.add('is-loaded'); }, 500); }
    document.querySelectorAll('.wl-ph img').forEach(function (img) {
      if (img.complete && img.naturalWidth) shown(img);
      else img.addEventListener('load', function () { shown(img); }, { once: true });
    });

    /* VSL: load and play only on tap */
    document.querySelectorAll('[data-wl-vsl]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = document.createElement('video');
        v.src = btn.getAttribute('data-src');
        v.poster = btn.getAttribute('data-poster') || '';
        v.controls = true; v.autoplay = true; v.playsInline = true;
        v.setAttribute('playsinline', '');
        btn.replaceWith(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });

    /* embroidery loop: loads only when scrolled near */
    var loops = document.querySelectorAll('video[data-wl-loop]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          if (e.isIntersecting) {
            var v = e.target;
            if (!v.src) { v.src = v.getAttribute('data-src'); }
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else { e.target.pause(); }
        });
      }, { rootMargin: '300px 0px' });
      loops.forEach(function (v) { io.observe(v); });
    } else { loops.forEach(function (v) { v.src = v.getAttribute('data-src'); }); }

    /* buy now: color buttons swap photo and link */
    document.querySelectorAll('[data-wl-buy]').forEach(function (box) {
      var img = box.querySelector('[data-wl-buy-img]');
      var name = box.querySelector('[data-wl-buy-name]');
      var link = box.querySelector('[data-wl-buy-link]');
      box.querySelectorAll('[data-wl-color]').forEach(function (b) {
        b.addEventListener('mouseenter', function () { var i = new Image(); i.src = b.getAttribute('data-img'); }, { once: true });
        b.addEventListener('click', function () {
          box.querySelectorAll('[data-wl-color]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          if (img) { img.onload = function () { img.classList.add('is-in'); }; img.srcset = b.getAttribute('data-srcset'); img.src = b.getAttribute('data-img'); img.alt = b.getAttribute('data-alt'); }
          if (name) name.textContent = b.getAttribute('data-label');
          if (link) link.href = b.getAttribute('data-url');
        });
      });
    });

    /* long reviews: show 5 lines, Read more opens the full review */
    document.querySelectorAll('.wl-rev-grid blockquote').forEach(function (q) {
      q.classList.add('is-clamped');
      if (q.scrollHeight - q.clientHeight > 4) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'wl-more'; b.textContent = 'Read more';
        b.addEventListener('click', function () { var open = q.classList.toggle('is-clamped'); b.textContent = open ? 'Read more' : 'Show less'; });
        q.insertAdjacentElement('afterend', b);
      } else { q.classList.remove('is-clamped'); }
    });

    /* review sliders: one row that glides sideways, arrows never move */
    document.querySelectorAll('[data-wl-pager]').forEach(function (wrap) {
      var track = wrap.querySelector('.wl-rev-grid');
      var prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]'), dots = wrap.querySelector('.wl-dots');
      var pages = 1;
      function step() { var c = track.children[0]; if (!c) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 16; var per = Math.max(1, Math.round((track.clientWidth + gap) / (c.offsetWidth + gap))); return per * (c.offsetWidth + gap); }
      function build() {
        pages = Math.max(1, Math.ceil((track.scrollWidth - 4) / step()));
        dots.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var d = document.createElement('button'); d.type = 'button'; d.className = 'wl-dot';
          d.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + pages); d.innerHTML = '<span></span>';
          (function (k) { d.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); }); })(i);
          dots.appendChild(d);
        }
        var nav = wrap.querySelector('.wl-nav'); if (nav) nav.style.visibility = pages > 1 ? '' : 'hidden';
        sync();
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 8;
        var cur = Math.min(pages - 1, Math.round(track.scrollLeft / step()));
        if (track.scrollLeft >= max) cur = pages - 1;
        prev.setAttribute('aria-disabled', track.scrollLeft <= 8 ? 'true' : 'false');
        next.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false');
        Array.prototype.forEach.call(dots.children, function (d, j) { d.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      var t; track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', build);
      build();
    });

    /* phone bar appears after the first screen */
    var bar = document.querySelector('.wl-bar');
    if (bar) {
      var onScroll = function () { bar.classList.toggle('is-on', window.scrollY > 500); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  });
})();
